import apiClient from '@u/apiClient'

const STORAGE_KEY = 'impersonation'

function loadFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

function saveToStorage(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

function clearStorage() {
    localStorage.removeItem(STORAGE_KEY)
}

const persisted = loadFromStorage()

const state = () => ({
    active:           persisted?.active ?? false,
    token:            persisted?.token ?? null,
    logId:            persisted?.logId ?? null,
    impersonatedUser: persisted?.impersonatedUser ?? null,
    users:            [],
    loading:          false,
})

const mutations = {
    SET_IMPERSONATION(state, { token, logId, user }) {
        state.active           = true
        state.token            = token
        state.logId            = logId
        state.impersonatedUser = user
        saveToStorage({ active: true, token, logId, impersonatedUser: user })
    },
    CLEAR_IMPERSONATION(state) {
        state.active           = false
        state.token            = null
        state.logId            = null
        state.impersonatedUser = null
        clearStorage()
    },
    SET_USERS(state, users) {
        state.users = users
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
}

const actions = {
    async exchange({ commit }, code) {
        const response = await apiClient.post('impersonate/exchange', { code })
        const { token, impersonation_log_id, user } = response.data

        localStorage.setItem('token', token)
        commit('auth/setToken', token, { root: true })
        commit('SET_IMPERSONATION', { token, logId: impersonation_log_id, user })
    },

    async switchUser({ commit }, userId) {
        const response = await apiClient.post(`impersonate/switch/${userId}`)
        const { token, impersonation_log_id, user } = response.data

        localStorage.setItem('token', token)
        commit('auth/setToken', token, { root: true })
        commit('SET_IMPERSONATION', { token, logId: impersonation_log_id, user })

        window.location.reload()
    },

    async startImpersonation({ commit }, userId) {
        const response = await apiClient.post(`impersonate/start/${userId}`)
        const { token, impersonation_log_id, user } = response.data

        localStorage.setItem('token', token)
        commit('auth/setToken', token, { root: true })
        commit('SET_IMPERSONATION', { token, logId: impersonation_log_id, user })

        window.location.reload()
    },

    async stop({ commit }) {
        try {
            await apiClient.post('impersonate/stop')
        } finally {
            localStorage.removeItem('token')
            commit('auth/setToken', null, { root: true })
            commit('CLEAR_IMPERSONATION')
            window.location.href = '/connect'
        }
    },

    async fetchUsers({ commit }, search = '') {
        commit('SET_LOADING', true)
        try {
            const response = await apiClient.get('impersonate/users', { params: { search } })
            commit('SET_USERS', response.data.data ?? response.data)
        } finally {
            commit('SET_LOADING', false)
        }
    },
}

const getters = {
    isImpersonating:  (state) => state.active,
    impersonatedUser: (state) => state.impersonatedUser,
    logId:            (state) => state.logId,
    users:            (state) => state.users,
    loading:          (state) => state.loading,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}